export function toggleDrawer() {
  return {
    type: '@drawer/TOGGLE',
  };
}

export function changeDrawer(key, value) {
  return {
    type: '@drawer/CHANGING',
    payload: { key, value },
  };
}

export function clearDrawer() {
  return {
    type: '@drawer/CLEANING_UP',
  };
}

export function modifyTitle(title) {
  return {
    type: '@drawer/MODIFY_TITLE',
    payload: { title },
  };
}

export function requestNavigation() {
  return {
    type: '@drawer/REQUEST_NAVIGATION',
  };
}

export function requestFailed() {
  return {
    type: '@drawer/REQUEST_FAILED',
  };
}

export function requestSuccess(navigations) {
  return {
    type: '@drawer/REQUEST_SUCCESS',
    payload: { navigations },
  };
}
